import mailModuleRouteHandler from './mailModuleRouteHandler';
import { registerRoute as registerRouteFunction, RouterOptions } from 'owa-router';
import { lazyInitializeMailRoutes, lazyGetCurrentRoute } from 'owa-mail-routing';
import { getScopedPath } from 'owa-url';
import getRootVdirName from 'owa-url/lib/getRootVdirName';
import { addBottleneck } from 'owa-performance';
import { logUsage } from 'owa-analytics';

export let mailRouterOptions: RouterOptions = {
    routeGenerator: lazyGetCurrentRoute.import(),
    defaultRoute: '/',
};

export async function initializeMailRoutes(registerRoute: typeof registerRouteFunction) {
    // if a route exists then let's wait to download the routing logic
    if (testIfRouteExists()) {
        await lazyInitializeMailRoutes.importAndExecute(registerRoute);
    }
    registerRoute('/', mailModuleRouteHandler);
}

function testIfRouteExists(): boolean {
    const location = window?.location;
    const pathname = location?.pathname;
    const scopedPath = getScopedPath(getRootVdirName(location), pathname);
    const routeExists = scopedPath != pathname && scopedPath + '/inbox' != pathname;
    addBottleneck('r_e', routeExists ? 't' : 'f');
    if (routeExists) {
        logUsage('RouteExists', {
            scope: scopedPath,
            path: pathname,
        });
    }
    return routeExists;
}
